export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13531.1b5ec641.jpg";